import React from 'react';
import {connect} from 'react-redux';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {IRootState} from 'app/shared/reducers';
import {setRegistrationData} from 'app/entities/registration/registration.reducer';
import 'app/entities/registration/registration.scss';
import {CaseType} from 'app/shared/model/enumerations/case-type.model';
import {EmergencyType} from 'app/shared/model/enumerations/emergency-type.model';
import {underscoreToTitleCase} from 'app/shared/util/text-util';
import RegistrationButtons from './registration-buttons';

interface IPatientTypeProps extends StateProps, DispatchProps {
  handlePreviousStep: () => void;
  handleNextStep: () => void;
  currentStep: number;
}

const PatientType: React.FC<IPatientTypeProps> = (props: IPatientTypeProps) => {
  const {patientCase, locationType} = props;

  const handlePatientTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedType = e.target.value as CaseType;

    if (selectedType === CaseType.BOTH) {
      props.setRegistrationData({
        patientCase: {
          ...patientCase,
          type: selectedType,
          emergencyType: EmergencyType.POSTPARTUM
        }
      });
    } else if (selectedType === CaseType.BABY) {
      props.setRegistrationData({
        patientCase: {
          ...patientCase,
          type: selectedType,
          emergencyType: EmergencyType.NEONATAL
        }
      });
    } else {
      props.setRegistrationData({
        patientCase: {
          ...patientCase,
          type: selectedType,
          emergencyType: null
        }
      });
    }
  };


  return (
    <div>
      <h2 className="mb-4">Is this a mama or a newborn?</h2>
      <AvForm onValidSubmit={props.handleNextStep}>
        <AvRadioGroup name="radio-button-group" required value={patientCase?.type}>
          <Row>
            {Object.values(CaseType).map((type, index) => (
              <Col key={index}>
                <Label className="radio-button-label">
                  <AvRadio name="patientType" value={type} onChange={handlePatientTypeChange}
                           className="radio-button-input"/>
                  {underscoreToTitleCase(type)}
                </Label>
              </Col>
            ))}
          </Row>
        </AvRadioGroup>
        <RegistrationButtons
          currentStep={props.currentStep}
          handlePreviousStep={props.handlePreviousStep}
        />
      </AvForm>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  patientCase: state.registration.entity.patientCase,
  locationType: state.registration.entity.locationType,
});

const mapDispatchToProps = {
  setRegistrationData,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PatientType);
